import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'hooks/redux'

import strings from 'utils/strings.js'
import {
  EDIT_INTERNAL_FEATURES,
  VIEW_FEATURE_REVISION,
} from 'constants/authorization'
import ParameterValue from 'components/ParameterValue'
import Paragraph from 'components/patterns/Typography/Paragraph'
import { hasRight } from 'selectors/authorization'
import FeatureRevisionParameter from '../FeatureRevision/FeatureRevisionParameter'

const FeatureReadOnly = ({
  releaseNumber,
  subGroup,
  priority,
  successorCode,
  subGroups,
  isInternalFeature,
  minCompatibleVariant,
  featureId,
}) => {
  const canEditInternalFeature = useSelector(hasRight, EDIT_INTERNAL_FEATURES)
  const internalView = isInternalFeature && canEditInternalFeature
  const description = subGroups && subGroups[subGroup]
  const canViewRevision = useSelector(hasRight, VIEW_FEATURE_REVISION)

  return (
    <>
      {internalView && (
        <Paragraph verticalMargins="9px">
          <ParameterValue
            value={releaseNumber}
            label={strings.release_number}
            size="small"
          />
        </Paragraph>
      )}
      {canViewRevision && (
        <Paragraph verticalMargins="9px">
          <FeatureRevisionParameter featureId={featureId} />
        </Paragraph>
      )}
      <Paragraph verticalMargins="9px">
        <ParameterValue
          value={minCompatibleVariant}
          label={strings.minimum_diagnostic_variant}
          size="small"
        />
      </Paragraph>
      <Paragraph verticalMargins="9px">
        <ParameterValue
          value={subGroup ? `${subGroup} - ${description}` : strings.n_a}
          label={strings.subgroup}
          size="small"
        />
      </Paragraph>
      <Paragraph verticalMargins="9px">
        <ParameterValue
          value={priority}
          label={strings.priority}
          size="small"
        />
      </Paragraph>
      {internalView && (
        <Paragraph verticalMargins="9px">
          <ParameterValue
            value={successorCode}
            label={strings.successor_code}
            size="small"
          />
        </Paragraph>
      )}
    </>
  )
}

FeatureReadOnly.propTypes = {
  releaseNumber: PropTypes.string,
  subGroup: PropTypes.string,
  priority: PropTypes.number,
  successorCode: PropTypes.string,
  type: PropTypes.string,
  subGroups: PropTypes.object,
  isInternalFeature: PropTypes.bool,
  featureId: PropTypes.string,
  minCompatibleVariant: PropTypes.string,
}

export default FeatureReadOnly
